export default __webpack_public_path__ + "static/media/z010mi0b.fb1a5ff4.mp3";